export enum CatalogItemDomains {
  SOFTWARE = "software",
  HARDWARE = "hardware",
}

export enum CatalogURLQueryStrings {
  QUERY = "query",
  SORT = "sort",
  SORT_DIRECTION = "sortDirection",
  CATEGORY = "category",
  OS = "os",
  COST_CONDITION = "costCondition",
  NAME = "name",
  AMOUNT = "price.amount",
}

export enum AiForMeURLQueryStrings {
  QUERY = "query",
  SORT = "sort",
  JOB_FAMILY = "jobFamily",
  CATEGORIES = "categories",
  DATA_CLASSIFICATION = "dataClassification",
}

export const AMAZONIAN_ORDER_LABEL = "AMAZONIAN";

export enum ITOConsumers {
  AMZNHAM = "amznham",
  ITMP = "itmp",
}

export const AMZNHAM_OPEN_STATUSES = [
  "NEW",
  "PROCESSING",
  "PENDING_APPROVAL",
  "APPROVED",
  "PENDING_SHIPPING",
  "SHIPPED",
];

export const NOT_APPLICABLE_STRING = "N/A";
export const EMPTY_STRING = "";
export const EMPTY_ARRAY = [];
export const FREE_STRING = "Free";
export const BLANK_STRING = "_blank";

export const FIRST_ELEMENT = 0;
export const SECOND_ELEMENT = 1;
export const THIRD_ELEMENT = 2;
export const FOURTH_ELEMENT = 3;

export const HALF_SECOND_IN_MS = 500;
export const DEFAULT_FLYOUT_MIN_WIDTH = 100;
export const DEFAULT_GET_ORDER_LIMIT = 50;
export const NOT_LISTED = "not-listed";

export const SUPPORT_TAGS = ["hw-order-support", "amazonian"];

export const ONE_HUNDRED_PERCENT_STRING = "100%";
export const SPACING_S200 = "S200";
export const SPACING_S500 = "S500";
export const SPACING_S400 = "S400";
export const MEDIUM = "medium";
export const ALIGN_ITEMS_CENTER = "center";
export const JUSTIFY_FLEX_END = "flex-end";

export const INFO_CARD_BORDER_COLOR = "#EBF5FD";
